"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseCurrencyType_1 = __importDefault(require("./BaseCurrencyType"));
const TICKER = 'USD';
class USDollars extends BaseCurrencyType_1.default {
    // N.B. on the Helium blockchain, USD is represented
    // with 8 decimal places
    constructor() {
        super(TICKER, 8);
    }
}
exports.default = USDollars;
//# sourceMappingURL=USDollars.js.map